import * as React from 'react';

type FireProps = {
    width?: number;
    height?: number;
    className?: string;
};

const Fire: React.FC<FireProps> = ({width = 12, height = 12, className}) => {
    return (
        <svg
            width={width}
            height={height}
            className={className}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" rx="8" fill="#FFCC32" />
            <path
                d="M10.9203 4.01648C11.0198 4.04243 11.1088 4.09875 11.1749 4.17761C11.241 4.25647 11.2808 4.35396 11.2889 4.45652L11.7085 9.74734C11.7084 11.7946 10.0426 13.4604 7.99532 13.4605C7.50802 13.4608 7.02546 13.3649 6.57536 13.1782C6.12526 12.9915 5.71649 12.7177 5.37253 12.3725C4.69899 11.699 4.28172 10.7678 4.28211 9.74027L4.34987 4.83943C4.35125 4.74217 4.38126 4.64746 4.43615 4.56714C4.49103 4.48682 4.56836 4.42444 4.65847 4.38781C4.74859 4.35117 4.8475 4.34188 4.94285 4.36112C5.03821 4.38036 5.12578 4.42726 5.19464 4.49597L6.35022 5.65155L7.51931 1.55936C7.54921 1.45627 7.61176 1.36566 7.69757 1.30117C7.78338 1.23668 7.8878 1.20179 7.99514 1.20175C8.10248 1.2017 8.20692 1.23651 8.29277 1.30093C8.37862 1.36535 8.44124 1.45591 8.4712 1.55898L9.57731 5.43087L10.3836 4.2213C10.4408 4.1357 10.5231 4.07001 10.6193 4.03331C10.7155 3.99661 10.8206 3.99073 10.9203 4.01648ZM6.41979 8.17181C6.00196 8.58964 5.76721 9.15633 5.76719 9.74722C5.76716 10.3381 6.00187 10.9048 6.41967 11.3226C6.83747 11.7404 7.40414 11.9751 7.99503 11.9751C8.58591 11.975 9.1526 11.7403 9.57043 11.3225C10.1201 10.7728 10.3204 10.0075 10.1758 9.29929C10.1499 9.3322 10.1261 9.36651 10.0956 9.39696C9.992 9.5006 9.86664 9.57994 9.72862 9.62926C9.5906 9.67858 9.44336 9.69665 9.29752 9.68216C9.15167 9.66767 9.01087 9.62098 8.88526 9.54547C8.75965 9.46995 8.65238 9.3675 8.57117 9.24549C8.48997 9.12349 8.43687 8.98497 8.41569 8.83995C8.39452 8.69493 8.4058 8.54701 8.44873 8.40687C8.49166 8.26673 8.56516 8.13787 8.66393 8.02958C8.7627 7.92129 8.88428 7.83627 9.01989 7.78066C8.1804 7.34309 7.12489 7.46671 6.41979 8.17181Z"
                fill="#E90000"
            />
        </svg>
    );
};

export default Fire;
